var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "business-list" } }, [
    _c("div", { staticClass: "mi-bl-header" }, [
      _c("strong", { staticStyle: { color: "#1f1f1f", "font-size": "14px" } }, [
        _vm._v(_vm._s(_vm.$t("metaInsights.selectBusiness"))),
      ]),
      _vm._v(" "),
      _c("span", { staticStyle: { color: "#6b7280", "font-size": "12px" } }, [
        _vm._v(_vm._s(_vm.$t("metaInsights.selectBusinessDesc"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mi-bl-list" },
      [
        _vm._l(_vm.itemsWithPersonal, function (biz) {
          return _c(
            "div",
            {
              key: biz.id,
              staticClass: "mi-bl-row",
              class: { "mi-bl-selected": _vm.isSelected(biz) },
              on: {
                click: function ($event) {
                  return _vm.select(biz)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "mi-bl-radio",
                  class: { "mi-bl-radio-checked": _vm.isSelected(biz) },
                },
                [
                  _vm.isSelected(biz)
                    ? _c("span", { staticClass: "mi-bl-dot" })
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "mi-bl-icon",
                  class: { "mi-bl-icon-personal": biz.id === "personal" },
                },
                [
                  biz.id === "personal"
                    ? _c("i", { staticClass: "material-icons" }, [
                        _vm._v("person"),
                      ])
                    : _c("i", { staticClass: "material-icons" }, [
                        _vm._v("business"),
                      ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mi-bl-info" }, [
                _c(
                  "div",
                  {
                    staticClass: "mi-bl-name",
                    staticStyle: {
                      "font-weight": "600",
                      "font-size": "14px",
                      color: "#1f1f1f",
                      "line-height": "1.4",
                      "word-break": "break-word",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(biz.name) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mi-bl-meta" }, [
                  biz.id !== "personal"
                    ? _c(
                        "span",
                        {
                          staticClass: "mi-bl-badge",
                          staticStyle: {
                            background: "#f0f0f0",
                            color: "#595959",
                            "font-family":
                              "ui-monospace, SFMono-Regular, monospace",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(biz.id) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  biz.verification_status
                    ? _c(
                        "span",
                        {
                          staticClass: "mi-bl-badge",
                          style: _vm.verificationBadgeStyle(
                            biz.verification_status
                          ),
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: { "font-size": "12px" },
                            },
                            [_vm._v("verified")]
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(biz.verification_status) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  biz.id === "personal"
                    ? _c(
                        "span",
                        {
                          staticClass: "mi-bl-badge",
                          staticStyle: {
                            background: "#fff7e6",
                            color: "#d48806",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("metaInsights.personalAdAccounts")
                              ) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        !_vm.itemsWithPersonal || _vm.itemsWithPersonal.length === 0
          ? _c("div", { staticClass: "mi-bl-empty" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("metaInsights.noBusinesses")) +
                  "\n        "
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }